const votingSection = document.querySelector(".produse-participante-section");
let votingCards = document.querySelectorAll("[data-magazin]");
let votingButtons = document.querySelectorAll(".votes_icons");
let data_format = [];

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Adaugă zilele în milisecunde
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`; // Setează cookie-ul pe root
}

function getCookie(name) {
    const nameEQ = name + "=";
    const cookiesArray = document.cookie.split(';');
    for (let cookie of cookiesArray) {
        while (cookie.charAt(0) === ' ') cookie = cookie.substring(1); // Elimină spațiile
        if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length); // Returnează valoarea
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log(`Cookie-ul cu numele "${name}" a fost șters.`);
}

const isIdVot = getCookie("idVotCraciun");
let allIdVots = [];

const get_data = async (query) => {
  await votingCards.forEach((item) => {
    if (item.dataset.magazin != "") {
      item.style.pointerEvents = "none";
      data_format.push({
        data_vot: item.dataset.vot,
        data_type_vot: item.dataset.typeVot,
        data_magazin: item.dataset.magazin,
        data_number_vot: 0,
      });
    }
  });

  const url = `https://api-mobexpert.herokuapp.com/api/vot/v1${query}`;
  const options = {
    method: "GET",
    mode: "cors",
    header: { "Content-Type": "application/json" },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    allIdVots = data.idVot;
    console.log("allIdVots", allIdVots);

    if (data.listaVot.length > 0) {
      votingCards.forEach((item) => {
        let is_shop_vote = false;
        data.listaVot.forEach((card) => {
          if (card.magazin === item.dataset.magazin) {
            item.querySelector(".vote-count").innerHTML = card.voturi;
            is_shop_vote = true;
            updateDataFormat(
              data_format,
              item.dataset.magazin,
              "data_number_vot",
              card.voturi
            );
            item.style.pointerEvents = "auto";
          }
        });

        if (data.notExist) {
          deleteCookie("idVotCraciun");
          // console.log("true");
        }

        if (!is_shop_vote) {
          item.querySelector(".vote-count").innerHTML = 0;
          item.style.pointerEvents = "auto";
        }

        if (data.idVot) {
          data.idVot.forEach((vote) => {
            if (vote.magazin === item.dataset.magazin) {
              if (item.dataset.vot == "no") {
                item.dataset.vot = "yes";
                item.dataset.typeVot = vote.vot;
                updateDataFormat(
                  data_format,
                  item.dataset.magazin,
                  "data_vot",
                  "yes"
                );
                updateDataFormat(
                  data_format,
                  item.dataset.magazin,
                  "data_type_vot",
                  vote.vot
                );
              }

              if (vote.vot) {
                if (item.dataset.typeVot == "LIKE") {
                  item.querySelector(".like_votes").classList.add("active");
                } else if (item.dataset.typeVot == "DISLIKE") {
                  item.querySelector(".dislike_votes").classList.add("active");
                }
              }
            }
          });
        }
      });
    } else {
      votingCards.forEach((item) => {
        item.querySelector(".vote-count").innerHTML = 0;
        item.style.pointerEvents = "auto";
      });
    }
  } catch (e) {
    console.log(e.message);
  }
  // console.log(data_format);
};
const randomNumber = (size_number) => {
  let random_number = "";
  for (let i = 0; i < size_number; i++) {
    random_number += Math.floor(Math.random() * 9);
  }

  return random_number;
};

document.addEventListener("DOMContentLoaded", () => {
  if (isIdVot) {
    get_data(`/lista-voturi?votName=votCraciun&idVot=${isIdVot}`);
  } else {
    get_data(`/lista-voturi?votName=votCraciun`);
  }
});

votBtns(votingButtons);

function votBtns(arrBot) {
  arrBot.forEach((btn) => {
    btn.addEventListener("click", async () => {
      const isIdVotClick = getCookie("idVotCraciun");
      const container_magazin_el = btn.parentNode.parentNode;
      const votingCard = container_magazin_el.dataset.magazin;
      const vot_el = container_magazin_el.dataset.vot;
      const type_vot_el = container_magazin_el.dataset.typeVot;
      console.log(isIdVotClick);
      console.log(container_magazin_el);
      console.log(votingCard);
      console.log(vot_el);
      console.log(type_vot_el);
      container_magazin_el.style.pointerEvents = "none";
      // console.log("vot_el -->", vot_el);

      let vot_id,
        method,
        type_vot,
        url_req,
        add = false;
      const id = btn.dataset.id;
      updateLoadingState(id, true);

      const currentButtons =
        container_magazin_el.querySelectorAll(".votes_icons");
      if (btn.classList.contains("active")) {
        btn.classList.remove("active");
      } else {
        currentButtons.forEach((btn) => {
          btn.classList.remove("active");
        });
        btn.classList.add("active");
      }

      if (isIdVotClick) {
        vot_id = isIdVotClick;
        method = "PATCH";
        url_req = `https://api-mobexpert.herokuapp.com/api/vot/v1/lista-voturi/actualizare?votName=votCraciun&idVot=${isIdVotClick}`;
        if (vot_el == "no") {
          type_vot = btn.dataset.btn != "decrement" ? "LIKE" : "DISLIKE";
          allIdVots.forEach((votMag) => {
            if (votMag.magazin != votingCard) {
              add = true;
            }
          });
          container_magazin_el.dataset.vot = "yes";
          // console.log(container_magazin_el);
        } else {
          if (type_vot_el == "LIKE" && btn.dataset.btn == "increment") {
            type_vot = "UNLIKE";
          } else if (
            type_vot_el == "DISLIKE" &&
            btn.dataset.btn == "decrement"
          ) {
            type_vot = "UNDISLIKE";
          } else {
            type_vot = btn.dataset.btn != "decrement" ? "LIKE" : "DISLIKE";
          }
        }
      } else {
        vot_id = randomNumber(15);
        url_req = `https://api-mobexpert.herokuapp.com/api/vot/v1/lista-voturi/nou?votName=votCraciun&idVot=${vot_id}`;
        method = "POST";
        type_vot = btn.dataset.btn != "decrement" ? "LIKE" : "DISLIKE";
        vot = "yes";
      }

      const data = {
        id: vot_id,
        vot: type_vot,
        magazin: votingCard.trim(),
        add: add,
      };

      console.log(data);

      const url = url_req;
      const options = {
        method: method,
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };

      // console.log(options);

      try {
        const response = await fetch(url, options);
        const data = await response.json();

        // console.log(data);

        votingCards.forEach((item) => {
          data.listaVot.forEach((magazin_gs) => {
            if (magazin_gs.magazin === item.dataset.magazin) {
              item.querySelector(".vote-count").innerHTML = magazin_gs.voturi;
            }
          });
        });

        if (!isIdVotClick) {
          setCookie("idVotCraciun", vot_id, 31)
        }

        allIdVots = data.idVot;
        container_magazin_el.dataset.typeVot = type_vot;
        container_magazin_el.style.pointerEvents = "auto";
        votingCards = document.querySelectorAll("[data-magazin]");
      } catch (e) {
        container_magazin_el.style.pointerEvents = "auto";
        console.log(e.message);
      }
    });
  });
}

function updateDataFormat(arr, shop, name, value) {
  arr.forEach((item) => {
    if (item.data_magazin == shop) {
      item[name] = value;
    }
  });
}

function updateLoadingState(id, isLoading) {
  const voteCount = document.getElementById(`voteCount-${id}`);
  const iconsWrapper = document.getElementById(`iconVotes-${id}`);

  if (isLoading) {
    voteCount.innerHTML =
      '<svg width="22" height="22" fill="#999" viewBox="0 0 26.349 26.35" xml:space="preserve"><g><g><circle cx="13.792" cy="3.082" r="3.082"/><circle cx="13.792" cy="24.501" r="1.849"/><circle cx="6.219" cy="6.218" r="2.774"/><circle cx="21.365" cy="21.363" r="1.541"/><circle cx="3.082" cy="13.792" r="2.465"/><circle cx="24.501" cy="13.791" r="1.232"/><path d="M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05 C6.902,18.996,5.537,18.988,4.694,19.84z"/><circle cx="21.364" cy="6.218" r="0.924"/></g></g></svg>';
    voteCount.classList.add("animated");
  } else {
    voteCount.classList.remove("animated");
  }
}
